
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 12.074C24 5.404 18.625 0 12 0 5.37 0 0 5.404 0 12.074 0 18.1 4.387 23.095 10.125 24v-8.435H7.078v-3.49h3.047V9.413c0-3.025 1.789-4.696 4.53-4.696 1.314 0 2.689.236 2.689.236v2.97h-1.516c-1.488 0-1.953.933-1.953 1.887v2.264h3.328l-.535 3.49h-2.793V24C19.609 23.094 24 18.1 24 12.074z","fill":"#625A54"}})])
          )
        }
      }
    